
<template>

<div style="margin-top: 50px;">
    <h2>FAQ</h2>

<section class="faqWrapper">
    <div class="faqLineWrapper">
        <div class="question" onclick="document.getElementById('faq1').classList.toggle('open');">What is an eSIM and how to use it? <span>+</span></div>
        <div class="faqAnswerWrapper" id="faq1">
            <div class="answer">


<p v-html="jsonContent.faq1" />

<!-- <p>An eSIM is an industry-standard digital SIM that allows you to activate a cellular plan without having to use a physical SIM.</p>
<p>We, in partnership with Telenor Maritime, deliver the WORLD Data eSIM solution through Vodafone Travel SIM to keep you connected the whole journey. </p>
<p>Note that the data connection onboard is provided by Telenor Maritime mobile network through satellite. The speed is therefore limited by the satellite link capacity.  </p>
<p>You can find the full installation and activation guide for our ESIM <a target="_blank" style="color: #fff;" href="https://travel.vodafone.com/help-support/activation-and-installation">here</a>.</p> -->
               
            </div>
        </div>
       
    </div>

    <div class="faqLineWrapper">
        <div class="question" onclick="document.getElementById('faq2').classList.toggle('open');" >
            <div v-html="jsonContent.faq2Question"></div>
            <span>+</span></div>
        
        <div class="faqAnswerWrapper" id="faq2">
        <div class="answer">
            <div class="multiColumn" v-html="jsonContent.faq2"></div>

        <div v-if="showFullCovarageMap">
            <p><a style="cursor: pointer; text-decoration: underline;margin-bottom: 10px; font-weight: bold;  display: block;" v-on:click='modalCoverage = !modalCoverage;'>
                Check out the full coverage map here.</a></p>
        </div>

        </div>
       
          
        </div>
    </div>

    <div class="faqLineWrapper" v-if="showNotUsedIn">
        <div class="question" onclick="document.getElementById('faq3').classList.toggle('open');">Which destinations can the eSIM NOT be used in? <span>+</span></div>
        <div class="faqAnswerWrapper" id="faq3">
            <div class="answer multiColumn"  v-html="jsonContent.faq3">


        </div>
        </div>
        
    </div>


    <div class="faqLineWrapper">
        <div class="question" onclick="document.getElementById('faq4').classList.toggle('open');">What phones support eSIMs? <span>+</span></div>
        <div class="faqAnswerWrapper" id="faq4">
            <div class="answer">
                

                Please check the compatibility of your phone <a style="cursor: pointer; text-decoration: underline; font-weight: bold;" v-on:click="showModal = !showModal">here</a>, by entering your device's manufacturer or model.

            </div>
        </div>
       
    </div>

    <div class="faqLineWrapper">
        <div class="question" onclick="document.getElementById('faq5').classList.toggle('open');">When will I receive my eSIM QR Code?? <span>+</span></div>
        <div class="faqAnswerWrapper" id="faq5">
            <div class="answer" v-html="jsonContent.faq5">
              
            </div>
        </div>
       
    </div>

</section>


</div>



</template>

<style>
.faqWrapper {
    width: 600px;
    max-width: 90%;
    margin: 25px auto;
    text-align: left;

}
.faqLineWrapper {
    margin: 15px 0;
}

.faqLineWrapper .question {
    font-size: 1.1rem;
    font-weight: bold;
    text-align: center;
    padding: 10px 35px;
    background-color: #F1ECE7;
    color: #6B207D;
    position: relative;
    cursor: pointer;
}
.faqLineWrapper .question span{
position: absolute;
right: 10px;
top:2px;
font-size: 1.8rem;
}

.faqLineWrapper .answer {
    border: 1px solid #F1ECE7;
    padding: 10px;

    
}

.multiColumn {
    columns: 3;

}


.faqAnswerWrapper {
	overflow-y: hidden;
	max-height: 500px; /* approximate max height */
    max-height: 0px;
	transition-property: all;
	transition-duration: .2s;
}

.faqAnswerWrapper.open {
	
    max-height: 500px; /* approximate max height */
}

@media only screen and (max-width: 550px)  {
    .multiColumn {
    columns: 2;
} 
}

@media only screen and (max-width: 320px)  {
    .multiColumn {
    columns: 1;
} 
}
</style>


<script setup>
  import { onBeforeMount,defineProps } from 'vue'
  import { modalCoverage,showModal } from '@/modules/modules.js'
  import { jsonContent,getContent } from '@/modules/content.js'
  import { useRouter } from 'vue-router'

  const props = defineProps({
company: String
})



let showNotUsedIn = true;
let showFullCovarageMap = true;

if(props.company == "carnival")
{
    showNotUsedIn = false;
    showFullCovarageMap = false;
}

const router = useRouter()
  
  onBeforeMount(async () => {
    getContent(router.currentRoute.value.params.id);


  })






</script>